const translations: Record<string, Record<string, string>> = {
  en: {},
  de: {},
};

let currentLocale = "en";

export function setLocale(locale: string): void {
  if (translations[locale]) {
    currentLocale = locale;
  }
}

export function getLocale(): string {
  return currentLocale;
}

export function t(
  key: string,
  params?: Record<string, string | number>,
  fallback?: string,
): string {
  const dict = translations[currentLocale];
  // F-S15: a missing key must never render raw — callers localizing
  // data-driven content pass the JSON value as the fallback.
  let text = dict?.[key] ?? fallback ?? key;

  if (params) {
    for (const [k, v] of Object.entries(params)) {
      text = text.replace(`{{${k}}}`, String(v));
    }
  }

  return text;
}

/**
 * The data-content localization seam (BL-113): names/descriptions that live in
 * `public/data/*.json` (the EN source of truth) render via
 * `t("<type>.<id>")` with the JSON value as the fallback — DE lights up where
 * a key exists, EN never regresses, and a raw key can never render.
 * `id` may carry a sub-field suffix (e.g. `"scout.short"`, `"steam.desc"`).
 */
export function localizedName(
  type: "enemy" | "card" | "tower" | "synergy",
  id: string,
  fallback: string,
): string {
  return t(`${type}.${id}`, undefined, fallback);
}

export function registerTranslations(
  locale: string,
  entries: Record<string, string>,
): void {
  if (!translations[locale]) {
    translations[locale] = {};
  }
  Object.assign(translations[locale], entries);
}

/** All registered keys for a locale — the EN/DE parity gate introspects this. */
export function registeredKeys(locale: string): string[] {
  return Object.keys(translations[locale] ?? {});
}
